import { Provider } from './context';
import { Dialog } from './Dialog';

export function OperationDetails(props) {
  return (
    <Provider {...props}>
      <Dialog />
    </Provider>
  );
}
